var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeamMail = function SvgTeamMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.0375V20.6316C24 22.4632 22.5158 23.9474 20.6842 23.9474H3.31579C2.43639 23.9474 1.593 23.598 0.971172 22.9762C0.349341 22.3544 0 21.511 0 20.6316V10.0375L11.6198 16.4291C11.8566 16.5592 12.144 16.5592 12.3802 16.4291L24 10.0368V10.0375ZM20.6842 5C21.5498 5.00008 22.381 5.33862 23.0003 5.94331C23.6196 6.548 23.978 7.37089 23.9987 8.23621L12 14.8362L0.00126307 8.23558L0.00252643 8.17874C0.0378965 7.32374 0.402446 6.51553 1.01994 5.9231C1.63744 5.33068 2.46006 4.99992 3.31579 5H20.6842Z",
    fill: "#CDF75D"
  })));
};
export default SvgTeamMail;